import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import FormButtons from '../../../core/form/FormButtons';
import LocalFileInput from '../../../core/form/LocalFileInput';
import Table from '../../../core/form/Table';
import ImagePreview from '../../../core/layout/ImagePreview';
import Button from '../../../core/form/Button';
import FetchSelect from '../../../core/form/FetchSelect';
import { Roles } from '../../../core/util';
import Switch from '../../../core/form/Switch';

const GrammarForm = (props) => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      props.onSubmit();
    }}
  >
    <Row>
      {[Roles.ADMIN, Roles.CONTENT_ADMIN].includes(localStorage.role) && (
        <Column size={3}>
          <FetchSelect
            url="distributors"
            label="Distributor"
            value={get(props.values, 'distributor', '')}
            onChange={(distributor) => {
              props.onChange('distributor', distributor);
            }}
            resultTransformer={{
              text: 'name',
              value: 'id',
            }}
          />
        </Column>
      )}
      <Column size={7}>
        <TextInput
          required
          disabled={props.submitting}
          label="Name"
          value={get(props.values, 'name', '')}
          onChange={(value) => props.onChange('name', value)}
          errorText={get(props.errors, 'name', null)}
        />
      </Column>
      <Column size={2}>
        <Switch
          label="Disabled for AI Exercises"
          titleOn="True"
          titleOff="False"
          disabled={props.submitting || ['Vocabulary', 'Others'].includes(get(props.values, 'name', ''))}
          onChange={(value) => props.onChange('isDisabledForAIExercises', value)}
          value={get(props.values, 'isDisabledForAIExercises', false)}
          errorText={get(props.errors, 'isDisabledForAIExercises', null)}
        />
      </Column>
    </Row>
    <Row>
      <Column size={12}>
        <TextInput
          disabled={props.submitting}
          label="English Description"
          required
          value={get(props.values, 'englishDescription', '')}
          onChange={(value) => props.onChange('englishDescription', value)}
          errorText={get(props.errors, 'englishDescription', null)}
        />
      </Column>
      <Column size={12}>
        <TextInput
          disabled={props.submitting}
          label="Spanish Description"
          required
          value={get(props.values, 'spanishDescription', '')}
          onChange={(value) => props.onChange('spanishDescription', value)}
          errorText={get(props.errors, 'spanishDescription', null)}
        />
      </Column>
      <Column size={12}>
        <TextInput
          disabled={props.submitting}
          label="Portuguese Description"
          required
          value={get(props.values, 'portugueseDescription', '')}
          onChange={(value) => props.onChange('portugueseDescription', value)}
          errorText={get(props.errors, 'portugueseDescription', null)}
        />
      </Column>
    </Row>
    <Row>
      <Column size={12}>
        <LocalFileInput
          required
          onChange={props.onFileAdd}
          buttonLabel="Add image"
          accept="image"
          disabled={props.submitting || props.loading}
          errorText={get(props.errors, 'images', null)}
        />
      </Column>
    </Row>
    <Row>
      <Column size={24}>
        <Table
          rowKey="order"
          columns={[
            {
              label: 'Position',
              path: 'order',
              width: '100px',
            },
            {
              label: 'Image',
              path: 'file',
              width: '200px',
              render: (value) => {
                let image;
                if (typeof value === 'string') {
                  image = `${process.env.REACT_APP_FILES_URL}/${value}`;
                } else {
                  image = URL.createObjectURL(value);
                }
                return <img src={image} style={{ width: 'auto', height: '250px' }} alt="grammar-slide" />;
              },
            },
            {
              label: 'Actions',
              width: '150px',
              render: (value, row) => {
                return (
                  <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', alignItems: 'center' }}>
                    <ImagePreview src={row.file} disabled={props.submitting} />
                    <Button
                      icon="down"
                      tooltip="Move Down"
                      disabled={props.submitting}
                      loading={props.submitting}
                      onClick={() => props.onFileMove(row.order, 'down')}
                    />
                    <Button
                      icon="up"
                      tooltip="Move Up"
                      disabled={props.submitting}
                      loading={props.submitting}
                      onClick={() => props.onFileMove(row.order, 'up')}
                    />
                    <Button
                      icon="delete"
                      disabled={props.submitting}
                      loading={props.submitting}
                      onClick={() => props.onFileRemove(row.order)}
                    />
                  </div>
                );
              },
            },
          ]}
          rows={get(props.values, 'images', [])}
        />
      </Column>
    </Row>
    <FormButtons
      confirmLabel={props.values.id ? 'Update Grammar' : 'Create Grammar'}
      isDisabled={props.submitting || !props.isDirty()}
      isSubmitting={props.submitting}
      onReset={props.onReset}
    />
  </form>
);

GrammarForm.propTypes = {
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  isDirty: PropTypes.func,
  onFileAdd: PropTypes.func.isRequired,
  onFileMove: PropTypes.func.isRequired,
  onFileRemove: PropTypes.func.isRequired,
};

GrammarForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  isDirty: () => false,
  onSubmit: () => alert('submitted'),
  onReset: () => false,
};

export default GrammarForm;
